/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize, colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

const border = `1px solid ${colors.N40}`;

export const FileWrapper = styled.div`
  margin: ${gridSize() * 2}px 0;

  &:first-child {
    margin-top: 0;
  }

  &:last-child {
    margin-bottom: 0;
  }

  & + & {
    margin-top: 0;
  }

  & + :not(&) {
    border-top: none;
  }
`;

export const File = styled.div`
  border: ${border};
  border-radius: 5px;
  overflow: hidden;
`;

export const FileContent = styled.table`
  border-collapse: collapse;
  border-spacing: 0;
  font-size: 13px;
  line-height: 1.4;
  width: 100%;
`;

export const FileContentWrapper = styled.div`
  overflow-x: auto;
`;

export const FileFooter = styled.footer`
  align-items: center;
  background: ${token('color.background.neutral', colors.N20)};
  display: flex;
  min-height: 3em;
  padding: 0 ${gridSize()}px;
  border-top: ${border};
`;

export const FileHeader = styled.header`
  background: ${token('color.background.neutral', colors.N20)};
  display: flex;
  align-items: center;
  padding: ${gridSize()}px;
`;
